/* eslint-disable no-return-await */
/* eslint-disable class-methods-use-this */
import { ApiException } from '@eta/components';
import { ServiceCreator } from '../../ProviderManagement/Service/client';
import { ContactTypes, GetIntermediaryExternalResponseDto, GetTaxpayerIntermediariesResponseDto, IntermediaryDetailsResponseDto, IntermediaryRepresentationsRequestDto, SubmitApplicationRequestDto, UpdateContactDetailsDto } from '../../ProviderManagement/Service/proxy';

export class IntermediaryService  {

     public async GetIntermediaries(): Promise< GetIntermediaryExternalResponseDto | ApiException> {        
        const client = ServiceCreator.getProviderManagementPublicClient();
        return await client.getIntermediaries();   
    }

    public async SubmitApplication(body?: SubmitApplicationRequestDto): Promise<number> {        
        const client = ServiceCreator.getProviderManagementPublicClient();
        return await client.submitApplication(body);   
    }

    public async UpdateContactDetails(body?: UpdateContactDetailsDto): Promise<number> {        
        const client = ServiceCreator.getProviderManagementPublicClient();
        return await client.updateContactDetails(body);   
    }

    public async ValidationOTPcode(taxpayerID: number, oTPcode: string | null, contactType: ContactTypes): Promise<number | ApiException> {        
        const client = ServiceCreator.getProviderManagementPublicClient(true);
        return await client.validateContactDetails(taxpayerID,oTPcode,contactType);   
    }

    public async GetDetials(): Promise<IntermediaryDetailsResponseDto> {        
        const client = ServiceCreator.getProviderManagementPublicClient();
        return await client.getDetails();   
    }

    public async GetTaxpayerIntermediaries(name?: string | null | undefined, nameAr?: string | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined): Promise<GetTaxpayerIntermediariesResponseDto> {        
        const client = ServiceCreator.getProviderManagementPublicClient();
        return await client.getTaxpayerIntermediaries(name,nameAr,pageSize,pageNumber);   
    }

    public async SaveTaxpayerIntermediary(body?: IntermediaryRepresentationsRequestDto | undefined): Promise<number> {        
        const client = ServiceCreator.getProviderManagementPublicClient();
        return await client.saveTaxpayerIntermediaries(body);   
    }
}